//
// clamp-js.js
//

export default (function () {
    for (const toggle of document.querySelectorAll('[data-clamp]')) {
        $clamp(toggle, {clamp: toggle.dataset.clamp});
    }
})();